import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { User } from '@app/models/user-data';
import { ILink } from '@app/models/links';

@Injectable({
  providedIn: 'root'
})
export class AuthDOS {
  private authToken$ = new BehaviorSubject<boolean>(false);

  private _userSubject = new BehaviorSubject<User>(null);
  readonly user$ = this._userSubject.asObservable();

  private _releaseDateSubject = new BehaviorSubject<Date>(null);
  readonly releaseDate$ = this._releaseDateSubject.asObservable();

  private _menuLinksSubject = new BehaviorSubject<ILink[]>([]);
  readonly menuLinks$ = this._menuLinksSubject.asObservable();

  setAuthTokenFalse(): void {
    this.authToken$.next(false);
  }

  setAuthTokenTrue(): void {
    this.authToken$.next(true);
  }

  isAuthenticated = () => {
    return this.authToken$.value;
  };

  updateUser(data: User): void {
    this._userSubject.next(data);
  }

  getUserSnapshot(): User {
    return this._userSubject.value;
  }

  setReleaseDate(releaseDate: Date): void {
    this._releaseDateSubject.next(releaseDate);
  }

  getReleaseDateSnapshot(): Date {
    return this._releaseDateSubject.value;
  }

  setMenuLinks(links: ILink[]): void {
    this._menuLinksSubject.next(links);
  }
}
